import axios from 'axios';
import { API_URL } from '../config';

const COMPANY_URL = `${API_URL}/companies`;

export const companyService = {
    // Get all companies
    getAllCompanies: async () => {
        const response = await axios.get(COMPANY_URL);
        return response.data;
    },

    // Get a single company by ID
    getCompany: async (id) => {
        const response = await axios.get(`${COMPANY_URL}/${id}/`);
        return response.data;
    },

    // Create a new company
    createCompany: async (companyData) => {
        const response = await axios.post(COMPANY_URL, companyData);
        return response.data;
    },

    // Update a company
    updateCompany: async (id, companyData) => {
        const response = await axios.put(`${COMPANY_URL}/${id}/`, companyData);
        return response.data;
    },

    // Delete a company
    deleteCompany: async (id) => {
        await axios.delete(`${COMPANY_URL}/${id}/`);
    }
}; 